import React, { Component, PropTypes } from 'react'

import GridCell from '../grid-cell'
import GridContent from './grid-content'

class GridContentContainer extends Component {

  constructor(props) {
    super(props)

    this.el = null

    this.cellRenderer = this.cellRenderer.bind(this)
    this.setRef = this.setRef.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.gridRecomputeTime !== prevProps.gridRecomputeTime) {
      this.el.recomputeGridSize()
    }
  }

  setRef(ref) {
    this.el = ref
  }

  cellRenderer({ columnIndex, rowIndex, style }) {
    if (columnIndex === this.props.columnCount - 1) {
      return null // return null for the empty add new time column
    }

    return (
      <GridCell
        key={`${columnIndex}-${rowIndex}`}
        style={style}
        rowIndex={rowIndex}
        columnIndex={columnIndex}
        dates={this.props.dates}
        times={this.props.times}
      />
    )
  }

  render() {
    return (
      <GridContent {...this.props} cellRenderer={this.cellRenderer} setRef={this.setRef} />
    )
  }
}

GridContentContainer.propTypes = {
  columnCount: PropTypes.number.isRequired,
  dates: PropTypes.object.isRequired,
  times: PropTypes.object.isRequired,
  gridRecomputeTime: PropTypes.number.isRequired,
}

export default GridContentContainer



/** WEBPACK FOOTER **
 ** ./src/components/grid/grid-content/grid-content-container.js
 **/